import { memo } from 'react'

import { IconButton } from 'ui/components/Buttons'
import { Row } from 'ui/themes/globalStyles'

import { IconName } from '../../Icon'
import { Panel, PanelFace } from '../../Panel'
import { FilterPanelProps } from './FilterPanel.types'

export const FilterPanel = memo((props: FilterPanelProps) => {
  const {
    children,
    title = 'Filters',
    onReset,
    isDirty = false,
    expanded,
    onToggle,
    customActions,
    collapsible = true
  } = props

  return (
    <Panel
      face={PanelFace.SECONDARY}
      title={title}
      expanded={expanded}
      onToggle={onToggle}
      collapsible={collapsible}
      actions={
        <Row style={{ gap: '30px' }}>
          {isDirty ? (
            <IconButton icon={IconName.DELETE} face="negative" onClick={onReset}>
              Clear Filters
            </IconButton>
          ) : undefined}
          {customActions}
        </Row>
      }
    >
      {children}
    </Panel>
  )
})
